// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import { EnvironmentFullConfig } from './environment-config';
import { BuildiumIdentityLogLevel } from './buildium-identity-log.enum';

export const environment: EnvironmentFullConfig = {
    production: false,
    name: 'default',
    authServer: {
        configId: 'https://auth.buildiumstaging.com:BuildiumManagerApplication',
        authority: 'https://auth.buildiumstaging.com',
        client: {
            id: 'BuildiumManagerApplication',
            authority: ''
        },
        scopes: [
            'BuildiumManagerApi',
            'openid',
            'offline_access'
        ],
        logLevel: BuildiumIdentityLogLevel.None
    },
    sentry: {
        enabled: 'false',
        dsn: '',
        environment: '',
        release: ''
    },
    munchkin: {
        domain: '',
        id: '',
        formId: '0'
    }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
